import * as React from 'react'
import { AsyncButton, FormField, Input, Label, Modal, ProfileImage, useToast } from 'uxp/components'
import { IContextProvider, IUserDetails } from '../../uxp'
import { useIsAuthenticated } from './AuthHelper'
import axios from 'axios'

import './AuthHelperComponent.scss'

interface IAuthHelperComponentProps {
    context: IContextProvider,
    /**
     * interval to check if the user has authenticated
     */
    interval: number
}

interface IAuthHelperComponentInstanceProps {
    show: () => void
}

const AuthHelperComponent: React.ForwardRefExoticComponent<React.RefAttributes<IAuthHelperComponentInstanceProps> & IAuthHelperComponentProps> = React.forwardRef((props, ref) => {

    const { context, interval } = props
    const toast = useToast()

    const [show, setShow] = React.useState(false)
    const [userDetails, setUserDetails] = React.useState<IUserDetails>(null)
    const [password, setPassword] = React.useState('')
    const [processing, setProcessing] = React.useState(false)


    const isAuthenticated = useIsAuthenticated(context, interval)

    React.useImperativeHandle(ref, () => ({
        show: () => {
            setShow(true)
        }
    }))


    React.useEffect(() => {
        context.setLoginUIRef(ref as any)
    }, [])

    React.useEffect(() => {
        context.getUserDetails()
            .then(res => {
                setUserDetails(res)
            })
            .catch(e => console.log('AUTH HELPER:: unable to get the user details. Exception: ', e))
    }, [context])

    React.useEffect(() => {
        setShow(!isAuthenticated)
    }, [isAuthenticated])

    React.useEffect(() => {
        console.log('AUTH HELPER:: user details ', userDetails);
    }, [userDetails])

    async function login() {
        if (processing) return
        setProcessing(true)
        return new Promise<string>((done, nope) => {
            // validate 
            if (!password || password.trim().length === 0) {
                toast.error('Please enter your password')
                setProcessing(false)
                return nope('invalid password')
            }

            // this should not happen :) but better to validate 
            if (!userDetails || !userDetails.id || userDetails.id?.trim().length === 0) {
                toast.error('User id not found')
                setProcessing(false)
                return nope('User id not found')
            }

            const url = context.lucyUrl?.replace(/\/$/, "") + '/Auth/AuthenticateUser'

            let formData = new FormData()
            formData.set('login', userDetails.id)
            formData.set('password', password)

            axios.post(url, formData)
                .then(async res => {
                    const token = res.data
                    context.updateAPIKey(token)

                    await updateSession(token)
                    setProcessing(false)
                    setShow(false)
                    done('logged in')
                })
                .catch(e => {
                    setProcessing(false)
                    if (e.response) {
                        if (e.response.data && e.response.data === 'Invalid login id or password') {
                            toast.error('Invalid Password. Please enter a valid password')
                            return nope('invalid password')
                        }
                    }
                    console.log('exception ', e.toJSON());
                    toast.error('Unable to login. ' + e.message)
                    nope(e)
                })
        })
    }

    async function updateSession(token: string) {
        try {
            // load this dummy page to set the session

            const url = '/Apps/UXP/session?apikey=' + token

            axios.get(url)
                .then(res => {
                    console.log('reponse ', res);
                })
                .catch(e => {
                    console.log('Exception ', e);
                })

        }
        catch (e) {
            console.log('AUTH HELPER:: unable to update the session, Exception ', e);
        }
    }

    function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>, val: string) {
        if (e.key === 'Enter') {
            login()
        }
    }

    return <Modal
        show={show}
        onClose={async () => {

        }}
        className='uxp-auth-helper-component-modal'
        autoSize={true}
        backgroundDismiss={false}
    >
        <div className="uxp-auth-helper-loging-content">

            <div className="uxp-auth-helper-profile-image-container">
                <ProfileImage
                    name={userDetails?.name || ''}
                    image={userDetails?.profileImage || ''}
                />

                <div className="text"> {userDetails?.name || ''}</div>
            </div>

            <div className='description'>
                You have been logged out <br />
                Please enter your password and login to continue
            </div>

            <FormField>
                <Input
                    type='password'
                    value={password}
                    onChange={setPassword} placeholder="Enter your password"
                    onKeyDown={handleKeyDown}
                />
            </FormField>

            <div className='btn-container'>

                <AsyncButton
                    title='Login'
                    loadingTitle='Authenticating...'
                    onClick={login}
                />

            </div>
        </div>


    </Modal>

})

export default AuthHelperComponent